import {Box as MuiBox, BoxProps as MuiBoxProps} from '@mui/material'
import React from 'react'

export type BoxProps = MuiBoxProps

export function Box(props: BoxProps) {
  return <MuiBox {...props} />
}
